"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

var _sizes = require("HubStyleTokens/sizes");

var _misc = require("HubStyleTokens/misc");

var _Styles = require("../../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H4 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H4",
  componentId: "sc-1ai3l2q-0"
})(_templateObject(), _Styles.FONT_FAMILIES[_misc.HEADING_WEIGHT4], (0, _Styles.setFontSize)(_sizes.HEADING4));
H4.propTypes = (0, _extends2.default)({}, _Heading.default.propTypes);
H4.defaultProps = (0, _extends2.default)({}, _Heading.default.defaultProps, {
  tagName: 'h4'
});
H4.displayName = 'H4';
var _default = H4;
exports.default = _default;
module.exports = exports.default;